function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(60.000000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M342.5,520 L57.5,520 C25.794,520 0,494.206 0,462.5 L0,217.5 C0,185.794 25.794,160 57.5,160 L342.5,160 C374.206,160 400,185.794 400,217.5 L400,462.5 C400,494.206 374.206,520 342.5,520 Z M57.5,200 C47.851,200 40,207.851 40,217.5 L40,462.5 C40,472.149 47.851,480 57.5,480 L342.5,480 C352.149,480 360,472.149 360,462.5 L360,217.5 C360,207.851 352.149,200 342.5,200 L57.5,200 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M300,200 L100,200 C88.954,200 80,191.046 80,180 L80,120 C80,53.832 133.832,0 200,0 C266.168,0 320,53.832 320,120 L320,180 C320,191.046 311.046,200 300,200 Z M120,160 L280,160 L280,120 C280,75.888 244.112,40 200,40 C155.888,40 120,75.888 120,120 L120,160 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200,400 C166.916,400 140,373.084 140,340 C140,306.916 166.916,280 200,280 C233.084,280 260,306.916 260,340 C260,373.084 233.084,400 200,400 Z M200,320 C188.972,320 180,328.972 180,340 C180,351.028 188.972,360 200,360 C211.028,360 220,351.028 220,340 C220,328.972 211.028,320 200,320 Z",
  id: "Shape"
}));

var SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "520px",
  height: "520px",
  viewBox: "0 0 520 520"
}, props), _ref);

export default __webpack_public_path__ + "static/media/lock.fa65d2da.svg";
export { SvgLock as ReactComponent };